import { useMutation, useQueryClient } from "@tanstack/react-query";
import { partyLicensesKeys } from "Api/Queries/Licenses/usePartyLicensesQuery";
import {
  type CreateLicenseCommandResult,
  type CreateLicenseRequest,
  type LicenseDto,
  postLicenses,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (license: LicenseDto) => void;
  onError?: (error: unknown) => void;
};

export const useCreateLicenseMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: CreateLicenseRequest) => postLicenses(data),
    ),
    onSuccess: (data: CreateLicenseCommandResult) => {
      queryClient.invalidateQueries({ queryKey: partyLicensesKeys.all });
      onSuccess?.(data.license);
    },
    onError,
  });
};
